module.exports = __webpack_public_path__ + "static/media/20240530074717_IMG_7348-min.318bbdf2.JPG";